/**
 * Axios client for core-affiliate.
 *
 * VUE_APP_ROOT_API is inlined at build time (Vue CLI). Changing env after
 * `dist/` exists has no effect — rebuild with the target API host.
 * Bearer token is attached from Vuex on every request when present.
 */
import axios from 'axios';
import store from '@/store';

const CoreApi = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

CoreApi.interceptors.request.use((config) => {
  if (store.state.token) {
    const value = `Bearer ${store.state.token}`;
    if (config.headers && typeof config.headers.set === 'function') {
      config.headers.set('Authorization', value, true);
    }
    if (config.headers) {
      config.headers.Authorization = value;
    } else {
      config.headers = { Authorization: value };
    }
  }
  return config;
});

function Api() {
  return CoreApi;
}

export default Api;
